import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../lib/cn.js";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref
) {
  return (
    <input
      ref={ref}
      className={cn(
        "w-full h-9 rounded border bg-surface-panel px-2.5 text-sm text-text-primary placeholder:text-text-muted",
        "focus:outline-none focus:ring-2 focus:ring-accent/40 focus:border-accent/70",
        invalid ? "border-status-danger/70" : "border-surface-border",
        className
      )}
      {...rest}
    />
  );
});
